import { Icon, Text } from '@msc-b2c/shared-components';
import styles from './headsupinfo.module.scss';
import { useSelector } from 'react-redux';
import { decodeHtmlEntities, RootState } from '@msc-b2c/shared-utils';
import clsx from 'clsx';
import { useState } from 'react';
import { HeadsUpIconAlignment } from '@msc-b2c/interfaces/enums';

export enum HeadsUpMessagePriority {
  DEFAULT,
  HIGH,
}

export interface HeadsUpInfoProps {
  icon: string;
  title: string;
  description: string;
  priority: HeadsUpMessagePriority;
  bgColor?: string;
  fontColor?: string;
  iconAlignment?: HeadsUpIconAlignment;
  closeIcon?: string;
  visibilityCondition: () => boolean | undefined;
}

function HeadsUpInfo({
  icon,
  title,
  description,
  bgColor,
  fontColor,
  iconAlignment = HeadsUpIconAlignment.MIDDLE,
  closeIcon,
}: Readonly<HeadsUpInfoProps>) {
  const drawerAEMConfig = useSelector((state: RootState) => state.myAreaCommonConfig.drawerProps);
  const [isVisible, setIsVisible] = useState(true);

  icon = icon ?? 'info-outline';
  title = title ?? '';
  description = description ?? '';

  const backgroundColor = bgColor ?? drawerAEMConfig.bannerColorPicker;
  const color = fontColor ?? drawerAEMConfig.fontColorPicker;

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={clsx(styles['headsUpContainer'], {
        [styles[`headsUpContainer--icon-${iconAlignment}`]]: !!iconAlignment,
      })}
      style={{ backgroundColor, color }}
    >
      <Icon
        icon={icon}
        ariaHidden={false}
      />
      <div className={styles['headsUpContainer__title']}>
        <Text
          styleOption={styles['headsUpContainer__title__label']}
          text={`${decodeHtmlEntities(title)}`}
        />
        <Text
          styleOption={styles['headsUpContainer__title__description']}
          text={`${decodeHtmlEntities(description)}`}
        />
      </div>
      {closeIcon && (
        <Icon
          icon={closeIcon}
          ariaHidden={false}
          styleOption={styles['headsUpContainer__closeIcon']}
          onClick={() => setIsVisible(false)}
        />
      )}
    </div>
  );
}

export default HeadsUpInfo;
